import Vue from "vue";
import Vuex from "vuex";

import Authentication from "@/store/modules/authentication";
import Certificates from "@/store/modules/certificates";
import Registrations from "@/store/modules/registrations";
import Reports from "@/store/modules/reports";
import Procedures from "@/store/modules/procedures";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    Authentication,
    Certificates,
    Registrations,
    Reports,
    Procedures,
  },
});
